import { IconProps } from './types'

export const CloseIcon = ({ className, width = 15, height = 15, viewBox = '0 0 15 15' }: IconProps) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none" aria-hidden="true">
    <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" />
  </svg>
)
